<template>
    <div class="flex flex-col items-center justify-items-center lg:px-64 md:px-32 sm:px-16 px-3 mb-40">
        <h2 class="mt-16 mb-10 tracking-wider font-semibold text-center text-3xl">{{ $route.params.title }}</h2>
        <tailwind-image
            v-if="linkExists(0)"
            :link="links[0]"
            aspect-ratio="7/12"
            class="w-full"
        ></tailwind-image>
        <div class="mt-5">
            Für das Kino-Programm der Kunsthalle Darmstadt wurde eine temporäre Kino-Tribüne entwickelt. Die Tribüne besteht aus gestapelten Paletten, die mit Spanngurten verzurrt sind. Die Paletten bilden eine stabile Lösung, die schnell und einfach aufgebaut werden kann. Das Tribünenobjekt fügt sich formal mit seiner hellen Holzstruktur und der schlichten und offenen Gestaltung in den Kontext der Kunsthalle Darmstadt ein. Das offene Palettenraster steht im Dialog mit der Deckenstruktur des Raums. Das Steigungsverhältnis der Tribüne ermöglicht den Kinobesuchern eine gute Sicht auf die Leinwand.
        </div>
        <div class="grid grid-cols-2 w-full mt-5">
            <tailwind-image
                v-if="linkExists(1)"
                :link="links[1]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
            <tailwind-image
                v-if="linkExists(2)"
                :link="links[2]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
        </div>
        <tailwind-image
            v-if="linkExists(3)"
            :link="links[3]"
            aspect-ratio="7/12"
            class="w-full my-5"
        ></tailwind-image>
        <div class="grid grid-cols-2 w-full mt-5">
            <tailwind-image
                v-if="linkExists(4)"
                :link="links[4]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
            <tailwind-image
                v-if="linkExists(5)"
                :link="links[5]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
        </div>
        <tailwind-image
            v-if="linkExists(6)"
            :link="links[6]"
            aspect-ratio="7/12"
            class="w-full my-5"
        ></tailwind-image>
        <div class="grid grid-cols-2 w-full mt-5">
            <tailwind-image
                v-if="linkExists(7)"
                :link="links[7]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
            <tailwind-image
                v-if="linkExists(8)"
                :link="links[8]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
        </div>
        <tailwind-image
            v-for="iLink in allRemainingLinks"
            :key="'VueKey' + iLink"
            :link="iLink"
            aspect-ratio="7/12"
            class="w-full my-5"
        ></tailwind-image>
        <span class="mt-5 w-full text-left">
            <p class="font-semibold">Entwurf und Realisierung</p>
            <p>Markus Holzbach mit Spacekitchen</p>
        </span>

    </div>
</template>
<script>
import TailwindImage from '@/components/TailwindImage';


export default {
    components: {
        TailwindImage,
    },
    props: {},
    data ()
    {
        return {
            links: [
                require( '@/assets/img/pc/kino_kunsthalle_3_a.jpg' ),
                require( '@/assets/img/pc/kino_kunsthalle_1_a.jpg' ),
                require( '@/assets/img/pc/kino_kunsthalle_4_b.jpg' ),
                // require( '@/assets/img/pc/kino_kunsthalle_5_b.jpg' ),
                // require( '@/assets/img/pc/kino_kunsthalle_6_b.jpg' ),
                // require( '@/assets/img/pc/kino_kunsthalle_7_a.jpg' ),
                require( '@/assets/img/pc/kino_kunsthalle_2_a.jpg' ),
            ],
        };
    },
    methods: {
        linkExists ( index )
        {
            return index in this.links;
        }
    },
    created () { },
    computed: {
        allRemainingLinks ()
        {
            if ( !this.linkExists( 9 ) )
            {
                return [];
            } else
            {
                return this.links.slice( 9 );
            }
        }
    }
};
</script>